import { render } from "./DemoFAQs.vue?vue&type=template&id=8e8ff66a&scoped=true"
import script from "./DemoFAQs.vue?vue&type=script&lang=js"
export * from "./DemoFAQs.vue?vue&type=script&lang=js"

import "./DemoFAQs.vue?vue&type=style&index=0&id=8e8ff66a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e8ff66a"]])

export default __exports__